import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function RequireAdmin({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center font-osd text-[#f5a623]" data-testid="admin-loading">
        CHECKING SIGNAL…
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  if (!user.is_admin) return <Navigate to="/admin/login" replace state={{ error: 'not_admin' }} />;
  return children;
}
